// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightningBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.46 14.658a1.5 1.5 0 0 0-.934-1.063l-6.805-2.551 1.75-8.75A1.5 1.5 0 0 0 18.904.976l-14 15a1.5 1.5 0 0 0 .57 2.429l6.805 2.551-1.75 8.75a1.5 1.5 0 0 0 2.567 1.318l14-15a1.5 1.5 0 0 0 .364-1.367ZM14.506 25.116l.965-4.822a1.5 1.5 0 0 0-.945-1.699l-5.901-2.211 8.866-9.5-.965 4.822a1.5 1.5 0 0 0 .945 1.699l5.904 2.211-8.869 9.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
